import { GetApp } from "../../App"
import { Block, BlockContainer, BlockRow } from "../../Components/Block"
import { Loading } from "../../Components/Loading"
import { AccountUserEditView } from "../AccountUser/EditView"
import { AccountSettingsUsersViewProps } from "./Params"

// One AccountUserEditView row per account user -- each with its own EditGroup, so a
// level change/deactivate/reactivate/remove on one row never touches another's fields
// (the earlier stub shared a single EditGroup with non-indexed field names across every
// row). There is no invite/"add user" action here: inviting a person (new or existing)
// only ever happens from the Ship-Users screen, which always creates a real ShipUser
// alongside the AccountUser -- an account-only invite (no ship) is not a supported
// state, so this view is management-only.

export function AccountSettingsUsersView({ accountUserInfos, accountUserLevelOptions, onChanged }: AccountSettingsUsersViewProps) {
  const app = GetApp();
  const t = app.getT("AccountSettingsView");

  return (
    <BlockContainer className="ShipContentView-empty-select  main-page-containers">

      <Block>
        <BlockRow>
          <h3>{t("users_list")}</h3>
        </BlockRow>

        {accountUserInfos == undefined ? <Loading /> : accountUserInfos.map((userInfo) => (
          <AccountUserEditView key={userInfo.user.id} userInfo={userInfo} accountUserLevelOptions={accountUserLevelOptions} onChanged={onChanged} />
        ))}
      </Block>

    </BlockContainer>
  );
}
